var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-daily-achievements',{attrs:{"background":"/images/game/w2d1/w2d1_success_bg.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }